// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { KeyboardCode, KeyboardCodes } from '@dnd-kit/core';

export const defaultKeyboardCodes: KeyboardCodes = {
  start: [KeyboardCode.Space, KeyboardCode.Enter],
  cancel: [KeyboardCode.Esc],
  end: [KeyboardCode.Space, KeyboardCode.Enter],
};



// WEBPACK FOOTER //
// /Volumes/src/internal/components/sortable-area/keyboard-sensor/defaults.ts